import { useCallback, useMemo } from 'react';

import { useDispatch } from 'react-redux';

import { useMultipleSelect } from 'components/modules/Insurance/hooks/useMultipleSelect';
import { insAnketaSetError, insAnketaSetErrors } from 'store/insuranceAnketa';
import { DRIVER_ERROR_PREFIX } from 'store/insuranceAnketa/constants';
import { selectDriverErrors } from 'store/insuranceAnketa/selectors';

import { ERRORS_STORE_FALLBACK, ERRORS_STORE_MAP } from '../DriverCard.constants';

export const useErrors = ({ id }) => {
  const dispatch = useDispatch();

  const driverKey = useMemo(() => {
    return DRIVER_ERROR_PREFIX + id;
  }, [id]);

  const { values: errors } = useMultipleSelect({
    fallback: ERRORS_STORE_FALLBACK,
    map: ERRORS_STORE_MAP,
    selector: selectDriverErrors(id),
  });

  const onSetError = useCallback(
    ({ key, value }) => {
      dispatch(insAnketaSetError({ id: driverKey, key, value }));
    },
    [driverKey]
  );
  const onSetErrors = useCallback(
    (errors) => {
      dispatch(insAnketaSetErrors({ errors: { [driverKey]: errors } }));
    },
    [driverKey]
  );

  return { errors, onSetError, onSetErrors };
};
